import type { RootState } from 'store'

export const getName = (state: RootState) =>
  state.geoIndication?.values?.name ?? ''
export const getCountry = (state: RootState) =>
  state.geoIndication?.values?.country ?? ''
export const getTranslations = (state: RootState) =>
  state.geoIndication?.values?.translations ?? []
export const getCode = (state: RootState) =>
  state.geoIndication?.values?.code ?? ''
export const getWineTerritoryType = (state: RootState) =>
  state.geoIndication?.values?.wineTerritoryType ?? ''
export const getWineRegionEU = (state: RootState) =>
  state.geoIndication?.values?.wineRegionEU ?? []
export const getParentGI = (state: RootState) =>
  state.geoIndication?.values?.parentGI ?? ''
export const getNationalGIType = (state: RootState) =>
  state.geoIndication?.values?.nationalGIType ?? []

export const getNameError = (state: RootState) =>
  state.geoIndication?.errors?.name
export const getCountryError = (state: RootState) =>
  state.geoIndication?.errors?.country
export const getCodeError = (state: RootState) =>
  state.geoIndication?.errors?.code
export const getWineTerritoryTypeError = (state: RootState) =>
  state.geoIndication?.errors?.wineTerritoryType
export const getWineRegionEUError = (state: RootState) =>
  state.geoIndication?.errors?.wineRegionEU
export const getParentGIError = (state: RootState) =>
  state.geoIndication?.errors?.parentGI
export const getNationalGITypeError = (state: RootState) =>
  state.geoIndication?.errors?.nationalGIType
